/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICittaStoreLocationsNewViewProps } from './citta-store-locations-new';

export default (props: ICittaStoreLocationsNewViewProps) => {
    return (
        <div className='row'>
            
        </div>
    );
};
